import { ResponsiveHidingProps, useFullTheme, ResponsiveMarginProps } from '~/design';
import { useResponsive } from '~/utils';
import { useResponsiveHideStyle } from '~/utils/styling';

export interface BleedProps extends ResponsiveMarginProps, ResponsiveHidingProps {
  children: React.ReactNode;
}

/**
 * `Bleed` is a basic layout component that allows its contents to be pulled towards a specific
 * direction using negative margin values. See this article for more details:
 * https://www.joshwcomeau.com/css/full-bleed/
 */
export function Bleed({ children, hideAbove, hideBelow, m, mb, ml, mr, mt, mx, my }: BleedProps) {
  const responsive = useResponsive();
  const { spacing } = useFullTheme();
  const marginStyle = responsive.css({
    margin: m && responsive.map(m, prop => `-${spacing[prop]}`),
    marginInline: mx && responsive.map(mx, prop => `-${spacing[prop]}`),
    marginBlock: my && responsive.map(my, prop => `-${spacing[prop]}`),
    marginTop: mt && responsive.map(mt, prop => `-${spacing[prop]}`),
    marginRight: mr && responsive.map(mr, prop => `-${spacing[prop]}`),
    marginBottom: mb && responsive.map(mb, prop => `-${spacing[prop]}`),
    marginLeft: ml && responsive.map(ml, prop => `-${spacing[prop]}`),
  });

  const hideStyle = useResponsiveHideStyle({ hideBelow, hideAbove });

  return <div css={[marginStyle, hideStyle]}>{children}</div>;
}
